import React from 'react';
import { PropInfo, CodeExample, NavTabProps, NavTabItemProps } from '@cimpress/react-components';

import NavTabCode from '!raw-loader!./navtab.jsx';
import NavTabDemo from './navtab.jsx';
import ComponentDoc from '../../shared/TabbedComponentDoc';

const NavTabDocs = () => {
  // NavTab proptypes
  const navTabPropInfos: PropInfo<NavTabProps>[] = [
    {
      name: 'children',
      type: 'node',
      default: '',
      description: 'Provide content for the NavTab as children.',
    },
    {
      name: 'className',
      type: 'string',
      default: '',
      description: 'Provide an additional class name for the nav tab.',
    },
    {
      name: 'vertical',
      type: 'boolean',
      default: 'false',
      description: 'Determines whether the tabs should be stacked vertically.',
    },
  ];

  // NavTabItem proptypes
  const navTabItemPropInfos: PropInfo<NavTabItemProps>[] = [
    {
      name: 'children',
      type: 'node',
      default: '',
      description: 'Provide content for the NavTabItem as children.',
    },
    {
      name: 'className',
      type: 'string',
      default: '',
      description: 'Provide an additional class name for the NavTabItem.',
    },
    {
      name: 'active',
      type: 'boolean',
      default: '',
      description: 'Determines whether this NavTabItem is active.',
    },
    {
      name: 'disabled',
      type: 'boolean',
      default: '',
      description: 'Determines whether this NavTabItem is disabled.',
    },
  ];

  return (
    <div>
      <ComponentDoc name="NavTab" propInfos={navTabPropInfos} />
      <ComponentDoc name="NavTabItem" propInfos={navTabItemPropInfos} includeTabs={false}>
        <NavTabDemo />
        <CodeExample code={NavTabCode} />
      </ComponentDoc>
    </div>
  );
};

export default NavTabDocs;
